export enum PlannerStatusEnum {
    PROPOSED = 'proposed',
    SCHEDULED = 'scheduled',
    FEEDBACK_LOOP = 'feedback_loop',
    APPROVED = 'approved',
    REPORTED = 'reported',
}